import React, { forwardRef, JSX} from 'react';
import {
  Input as _Input,
  InputProps as _InputProps,
} from '@rebass/forms/styled-components';

export type InputProps = _InputProps & {
  'data-testid'?: string;
  'data-tooltip-id'?: string;
  onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

/**
 * Input component.
 */
export const Input = forwardRef(
  ({ onEnter, onKeyDown, ...props }: InputProps, ref): JSX.Element => (
    <_Input
      {...props}
      ref={ref}
      onKeyDown={(e) => {
        onKeyDown?.(e);
        if (e.key === 'Enter') {
          onEnter?.(e);
        }
      }}
      sx={{
        borderRadius: 3,
        borderColor: 'transparent',
        bg: 'gray5',
        p: '0.9em',
        color: 'gray80',
        ...(props.sx || {}),
      }}
    />
  ),
);

Input.displayName = 'Input';

export default Input;
